// import React from "react";
// import { Button } from "@mui/material";
// import { useQuery } from "react-query";
// import { NavLink, useNavigate } from "react-router-dom";
// import { getStudy } from "../../Services/CaseStudy";

// const CaseStudy = () => {
//   const navigate = useNavigate();

//   const {
//     data: getCaseStudy,
//     isLoading,
//     isError,
//   } = useQuery({
//     queryKey: "get-case-study",
//     queryFn: getStudy,
//   });

//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-60">Loading...</div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="flex justify-center items-center h-60 text-red-500">
//         Failed to load Case Studies.
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Heading */}
//       <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
//         Case Studies
//       </p>

//       {/* Add Button */}
//       <div className="flex justify-end w-full px-2 my-4">
//         <NavLink to="/case-study/add">
//           <Button variant="outlined">Add</Button>
//         </NavLink>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto bg-white rounded-lg shadow">
//         <table className="w-full border-collapse">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="border p-3">Image</th>
//               <th className="border p-3">Title</th>
//               <th className="border p-3">Industry</th>
//               <th className="border p-3">Country</th>
//               <th className="border p-3">Platform</th>
//               <th className="border p-3">Created</th>
//               <th className="border p-3">Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {getCaseStudy?.data?.data?.length > 0 ? (
//               getCaseStudy.data.data.map((item) => (
//                 <tr key={item.id}>
//                   <td className="border p-3">
//                     <img
//                       src={item.image}
//                       alt={item.title}
//                       className="w-24 h-16 object-cover rounded"
//                     />
//                   </td>

//                   <td className="border p-3">
//                     <p className="font-semibold">{item.title}</p>
//                     <p className="text-xs text-gray-500">
//                       {item.project_snapshot}
//                     </p>
//                   </td>

//                   <td className="border p-3">{item.industry_vertical}</td>

//                   <td className="border p-3">{item.country}</td>

//                   <td className="border p-3">{item.platform}</td>

//                   <td className="border p-3">
//                     {new Date(item.created_at).toLocaleDateString()}
//                   </td>

//                   <td className="border p-3">
//                     <div className="flex justify-center gap-2">
//                       <Button
//                         variant="outlined"
//                         color="primary"
//                         onClick={() =>
//                           navigate("/case-study/view", {
//                             state: item.id,
//                           })
//                         }
//                       >
//                         View
//                       </Button>

//                       {/* <Button
//                         variant="outlined"
//                         color="warning"
//                         onClick={() =>
//                           navigate("/case-study/update", {
//                             state: item.id,
//                           })
//                         }
//                       >
//                         Update
//                       </Button> */}
//                       <Button
//                         variant="outlined"
//                         color="warning"
//                         onClick={() =>
//                           navigate("/case-study/update", {
//                             state: item.id,
//                           })
//                         }
//                       >
//                         Update
//                       </Button>

//                       <Button
//                         variant="outlined"
//                         color="error"
//                         // onClick={() => handleDelete(item.id)}
//                       >
//                         Delete
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" className="text-center p-5">
//                   No Case Study Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </>
//   );
// };

// export default CaseStudy;

// import React, { useState } from "react";
// import {
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
// import { useMutation, useQuery, useQueryClient } from "react-query";
// import { toast } from "react-toastify";
// import { NavLink, useNavigate } from "react-router-dom";
// import { deleteStudy, getStudy } from "../../Services/CaseStudy";

// const CaseStudy = () => {
//   const navigate = useNavigate();
//   const queryClient = useQueryClient();
//   const [openDeleteModal, setOpenDeleteModal] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);
//   const {
//     data: getCaseStudy,
//     isLoading,
//     isError,
//   } = useQuery({
//     queryKey: "get-case-study",
//     queryFn: getStudy,
//   });

//   // Delete Mutation
//   const { mutate: removeCaseStudy } = useMutation(deleteStudy, {
//     onSuccess: () => {
//       toast.success("Case Study Deleted Successfully");
//       queryClient.invalidateQueries("get-case-study");
//       setOpenDeleteModal(false);
//       setSelectedId(null);
//     },
//     onError: (error) => {
//       toast.error(
//         error?.response?.data?.message || "Failed to delete Case Study",
//       );
//       setOpenDeleteModal(false);
//     },
//   });

//   // Delete Handler
//   const handleDelete = (id) => {
//     setSelectedId(id);
//     setOpenDeleteModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenDeleteModal(false);
//     setSelectedId(null);
//   };

//   const confirmDelete = () => {
//     if (!selectedId) return;

//     removeCaseStudy({
//       case_study_id: selectedId,
//     });
//   };

//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-60">Loading...</div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="flex justify-center items-center h-60 text-red-500">
//         Failed to load Case Studies.
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* Heading */}
//       <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
//         Case Studies
//       </p>

//       {/* Add Button */}
//       <div className="flex justify-end w-full px-2 my-4">
//         <NavLink to="/case-study/add">
//           <Button variant="outlined">Add</Button>
//         </NavLink>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto bg-white rounded-lg shadow">
//         <table className="w-full border-collapse">
//           <thead className="bg-gray-100">
//             <tr>
//               <th className="border p-3">Image</th>
//               <th className="border p-3">Title</th>
//               <th className="border p-3">Industry</th>
//               <th className="border p-3">Country</th>
//               <th className="border p-3">Platform</th>
//               <th className="border p-3">Created</th>
//               <th className="border p-3">Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {getCaseStudy?.data?.data?.length > 0 ? (
//               getCaseStudy.data.data.map((item) => (
//                 <tr key={item.id}>
//                   <td className="border p-3">
//                     <img
//                       src={item.image}
//                       alt={item.title}
//                       className="w-24 h-16 object-cover rounded"
//                     />
//                   </td>

//                   <td className="border p-3">
//                     <p className="font-semibold">{item.title}</p>
//                     <p className="text-xs text-gray-500">
//                       {item.project_snapshot}
//                     </p>
//                   </td>

//                   <td className="border p-3">{item.industry_vertical}</td>

//                   <td className="border p-3">{item.country}</td>

//                   <td className="border p-3">{item.platform}</td>

//                   <td className="border p-3">
//                     {new Date(item.created_at).toLocaleDateString()}
//                   </td>

//                   <td className="border p-3">
//                     <div className="flex justify-center gap-2">
//                       {/* <Button
//                         variant="outlined"
//                         color="primary"
//                         onClick={() =>
//                           navigate("/case-study/view", {
//                             state: item.id,
//                           })
//                         }
//                       >
//                         View
//                       </Button> */}

//                       <Button
//                         variant="outlined"
//                         color="warning"
//                         onClick={() =>
//                           navigate("/case-study/update", {
//                             state: item.id,
//                           })
//                         }
//                       >
//                         Update
//                       </Button>

//                       <Button
//                         variant="outlined"
//                         color="error"
//                         onClick={() => handleDelete(item.id)}
//                       >
//                         Delete
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" className="text-center p-5">
//                   No Case Study Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       <Dialog
//         open={openDeleteModal}
//         onClose={handleCloseModal}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle sx={{ fontWeight: 600 }}>Delete Case Study</DialogTitle>

//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete this Case Study?
//           </DialogContentText>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseModal} variant="outlined">
//             Cancel
//           </Button>

//           <Button onClick={confirmDelete} variant="contained" color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default CaseStudy;

import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

import { deleteStudy, getStudy } from "../../Services/CaseStudy";
import { baseUrl } from "../../Config/baseUrl";

const CaseStudy = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // =========================
  // DELETE STATES
  // =========================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // =========================
  // PAGE STATES
  // =========================
  const [pages, setPages] = useState([]);
  const [selectedPageId, setSelectedPageId] = useState("");

  // =========================
  // GET PAGE API
  // =========================
  useEffect(() => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        console.log("PAGE API RESPONSE:", res.data);

        setPages(res.data?.data || []);
      })
      .catch((error) => {
        console.error("PAGE API ERROR:", error);
        toast.error("Failed to load pages");
      });
  }, []);

  // =========================
  // GET CASE STUDIES
  // =========================
  const {
    data: getCaseStudy,
    isLoading,
    isError,
  } = useQuery({
    queryKey: "get-case-study",
    queryFn: getStudy,
  });

  // All Case Studies
  const caseStudies = getCaseStudy?.data?.data || [];

  // =========================
  // PAGE WISE FILTER
  // =========================
  const filteredCaseStudies = selectedPageId
    ? caseStudies.filter(
        (item) => String(item.page_id) === String(selectedPageId),
      )
    : caseStudies;

  // =========================
  // DELETE MUTATION
  // =========================
  const { mutate: removeCaseStudy } = useMutation(deleteStudy, {
    onSuccess: () => {
      toast.success("Case Study Deleted Successfully");

      queryClient.invalidateQueries("get-case-study");

      setOpenDeleteModal(false);
      setSelectedId(null);
    },

    onError: (error) => {
      toast.error(
        error?.response?.data?.message || "Failed to delete Case Study",
      );

      setOpenDeleteModal(false);
    },
  });

  // =========================
  // DELETE HANDLER
  // =========================
  const handleDelete = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const handleCloseModal = () => {
    setOpenDeleteModal(false);
    setSelectedId(null);
  };

  const confirmDelete = () => {
    if (!selectedId) return;

    removeCaseStudy({
      case_study_id: selectedId,
    });
  };

  // =========================
  // LOADING
  // =========================
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-60">Loading...</div>
    );
  }

  // =========================
  // ERROR
  // =========================
  if (isError) {
    return (
      <div className="flex justify-center items-center h-60 text-red-500">
        Failed to load Case Studies.
      </div>
    );
  }

  return (
    <>
      {/* =========================
          HEADING
      ========================= */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Case Studies
      </p>

      {/* =========================
          PAGE FILTER + ADD BUTTON
      ========================= */}
      <div className="flex flex-col sm:flex-row justify-end gap-3 w-full px-2 my-4">
        {/* PAGE FILTER */}
        {/* <Autocomplete
          className="w-full sm:w-80"
          size="small"
          options={pages}
          getOptionLabel={(option) => option?.name || ""}
          value={
            pages.find(
              (page) =>
                String(page.id) === String(selectedPageId)
            ) || null
          }
          onChange={(event, newValue) => {
            setSelectedPageId(
              newValue ? newValue.id : ""
            );
          }}
          isOptionEqualToValue={(option, value) =>
            String(option.id) === String(value.id)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by Page"
            />
          )}
        /> */}

        {/* ADD BUTTON */}
        <NavLink to="/case-study/add">
          <Button variant="outlined">Add</Button>
        </NavLink>
      </div>

      {/* =========================
          SELECTED PAGE INFO
      ========================= */}
      {selectedPageId && (
        <div className="px-2 mb-3">
          <p className="text-sm text-gray-600">
            Showing Case Studies for:{" "}
            <span className="font-semibold text-blue-600">
              {
                pages.find((page) => String(page.id) === String(selectedPageId))
                  ?.name
              }
            </span>
          </p>
        </div>
      )}

      {/* =========================
          TABLE
      ========================= */}
      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="w-full border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-3">Image</th>
              <th className="border p-3">Title</th>
              <th className="border p-3">Page</th>
              <th className="border p-3">Industry</th>
              <th className="border p-3">Country</th>
              <th className="border p-3">Platform</th>
              <th className="border p-3">Created</th>
              <th className="border p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCaseStudies.length > 0 ? (
              filteredCaseStudies.map((item) => (
                <tr key={item.id}>
                  {/* IMAGE */}
                  <td className="border p-3">
                    {item?.image ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-24 h-16 object-cover rounded"
                      />
                    ) : (
                      <span className="text-gray-400">No Image</span>
                    )}
                  </td>

                  {/* TITLE */}
                  <td className="border p-3">
                    <p className="font-semibold">{item.title}</p>

                    <p className="text-xs text-gray-500">
                      {item.project_snapshot}
                    </p>
                  </td>

                  {/* PAGE */}
                  <td className="border p-3">
                    <span className="text-blue-600 font-medium">
                      {item.page_name || "Not Assigned"}
                    </span>
                  </td>

                  {/* INDUSTRY */}
                  <td className="border p-3">{item.industry_vertical}</td>

                  {/* COUNTRY */}
                  <td className="border p-3">{item.country}</td>

                  {/* PLATFORM */}
                  <td className="border p-3">{item.platform}</td>

                  {/* CREATED */}
                  <td className="border p-3">
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString()
                      : "-"}
                  </td>

                  {/* ACTION */}
                  <td className="border p-3">
                    <div className="flex justify-center gap-2">
                      <Button
                        variant="outlined"
                        color="warning"
                        onClick={() =>
                          navigate("/case-study/update", {
                            state: item.id,
                          })
                        }
                      >
                        Update
                      </Button>

                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center p-5">
                  {selectedPageId
                    ? "No Case Study Found for this Page"
                    : "No Case Study Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* =========================
          DELETE MODAL
      ========================= */}
      <Dialog
        open={openDeleteModal}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Delete Case Study</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Case Study?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseModal} variant="outlined">
            Cancel
          </Button>

          <Button onClick={confirmDelete} variant="contained" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CaseStudy;
